// All image assets are now hosted from the app's OWN /public directory so they
// come from the same origin as the HTML (welworthads.online). This eliminates
// third-party image blocking on ISPs/firewalls/mobile carriers that previously
// blocked customer-assets.emergentagent.com.
export const WELWORTH_LOGO = "/img/logo-welworth.jpg";

// Sample notice images shown on the homepage hero (English + Marathi + Change-of-Name).
export const SAMPLE_NOTICE_IMAGES = [
  {
    src: "/img/samples/sample-english.jpeg",
    alt: "Sample published Public Notice — English",
    label: "English",
  },
  {
    src: "/img/samples/sample-marathi.jpeg",
    alt: "Sample published Jahir Prakatan — Marathi",
    label: "Marathi",
  },
  {
    src: "/img/samples/sample-change-of-name.jpeg",
    alt: "Sample published Change of Name notice",
    label: "Change of Name",
  },
];

// kept for backward-compat with any code still importing the singular name
export const SAMPLE_NOTICE_IMG = SAMPLE_NOTICE_IMAGES[0].src;

export const COMPANY_INFO = {
  address: "Welworth Creative Media, Kranti Chowk, Chh. Sambhajinagar",
  email: "welworthadvt@gmail.com",
  phones: ["+91 77220 74451", "+91 97623 83215", "+91 98906 28251"],
  cities: ["Pune", "Mumbai", "Nashik"],
  domain: "welworthads.online",
};

export const NEWSPAPER_LOGOS = {
  "Times of India":   "/img/newspapers/times-of-india.jpg",
  "Sakal":            "/img/newspapers/sakal.jpg",
  "Punya Nagari":     "/img/newspapers/punya-nagari.jpg",
  "Lokmat":           "/img/newspapers/lokmat.jpg",
  "Divya Marathi":    "/img/newspapers/divya-marathi.jpg",
  "Lokmat Times":     "/img/newspapers/lokmat-times.jpg",
  "Lokmat Samachar":  "/img/newspapers/lokmat-samachar.jpg",
  "Maharashtra Times":"/img/newspapers/maharashtra-times.jpg",
  "Saamana":          "/img/newspapers/saamana.jpg",
};
